// Cookie consent modal (Figma node 16650:3139 desktop / 16947:8251 mobile).
// Markup: resources/views/frontend/shared/cookie-consent.blade.php.
// Consent state/storage comes from the vendored @el7ven/cookie-kit core
// (resources/frontend/js/vendor/cookie-kit/core.js) — this file only wires
// our own custom markup to it, no built-in cookie-kit UI is used.
//
// No close control by design (backdrop click / Esc are no-ops too, via
// FocusTrap's onEscape being left unset) — the user must click one of the
// three action buttons to dismiss the modal.
import $ from 'jquery';
import { createCookieKit } from '../vendor/cookie-kit/core.js';
import { FocusTrap } from '../vendor/cookie-kit/FocusTrap.js';

$(function () {
    const $root = $('[data-cookie-consent]');

    if (!$root.length) {
        return;
    }

    const core = createCookieKit({
        categories: {
            necessary: { id: 'necessary', required: true, enabled: true, disabled: true },
            statistics: { id: 'statistics', required: false, enabled: false },
            marketing: { id: 'marketing', required: false, enabled: false },
            preferences: { id: 'preferences', required: false, enabled: false }
        }
    });
    core.autoApplyGPC();

    const panelEl = $root.find('[data-cookie-panel]')[0];
    const focusTrap = new FocusTrap();

    let pendingState = core.getDefaultCategoriesState();

    const renderToggles = () => {
        $root.find('[data-cookie-toggle]').each(function () {
            const $toggle = $(this);
            const id = $toggle.data('cookieToggle');
            const isOn = !!pendingState[id];

            $toggle.toggleClass('is-on', isOn).attr('aria-checked', isOn ? 'true' : 'false');
        });
    };

    const setScreen = (name) => {
        $root.find('[data-cookie-screen]').each(function () {
            $(this).toggleClass('is-hidden', $(this).data('cookieScreen') !== name);
        });
    };

    const setActiveTab = (id) => {
        $root.find('[data-cookie-tab]').each(function () {
            $(this).toggleClass('is-active', $(this).data('cookieTab') === id);
        });
        $root.find('[data-cookie-tab-panel]').each(function () {
            $(this).toggleClass('is-hidden', $(this).data('cookieTabPanel') !== id);
        });
    };

    const show = (screen) => {
        setScreen(screen);
        $root.addClass('is-open');
        $('body').addClass('has-cookie-consent-open');
        if (panelEl) {
            focusTrap.activate(panelEl);
        }
    };

    const hide = () => {
        $root.removeClass('is-open');
        $('body').removeClass('has-cookie-consent-open');
        focusTrap.deactivate();
    };

    // Closes without saving any consent — nothing is written to storage,
    // so the banner reappears on the next page load (unlike the three
    // action buttons below, which all persist a decision via `core`).
    $root.on('click', '[data-cookie-close]', function () {
        hide();
    });

    $root.on('click', '[data-cookie-toggle]', function () {
        const $toggle = $(this);

        if ($toggle.is(':disabled') || $toggle.hasClass('cookie-toggle--locked')) {
            return;
        }

        const id = $toggle.data('cookieToggle');
        pendingState[id] = !pendingState[id];
        renderToggles();
    });

    $root.on('click', '[data-cookie-tab]', function () {
        setActiveTab($(this).data('cookieTab'));
    });

    $root.on('click', '[data-cookie-open-settings]', function () {
        setActiveTab('privacy');
        setScreen('settings');
    });

    $root.on('click', '[data-cookie-back]', function () {
        setScreen('banner');
    });

    $root.on('click', '[data-cookie-accept-selected]', function () {
        const selected = Object.keys(pendingState).filter((id) => pendingState[id]);
        core.acceptSelected(selected, 'banner');
        hide();
    });

    $root.on('click', '[data-cookie-reject-all]', function () {
        core.rejectAll('banner');
        pendingState = core.getDefaultCategoriesState();
        renderToggles();
        hide();
    });

    $root.on('click', '[data-cookie-accept-all]', function () {
        core.acceptAll('banner');
        Object.keys(pendingState).forEach((id) => { pendingState[id] = true; });
        renderToggles();
        hide();
    });

    // Reopens the modal (in the settings screen) from outside — the
    // temporary "Setări cookie" footer link, until it moves to its own
    // page.
    $(document).on('click', '[data-cookie-reopen]', function (event) {
        event.preventDefault();
        const consent = core.getConsent();
        pendingState = consent ? { ...consent.categories } : core.getDefaultCategoriesState();
        renderToggles();
        setActiveTab('privacy');
        show('settings');
    });

    renderToggles();

    // Delay before the banner first appears (ms). 0 = immediately.
    const BANNER_DELAY = 5000;

    if (!core.hasConsent()) {
        setTimeout(() => {
            // Skip if it was already opened manually (footer link) meanwhile.
            if (!$root.hasClass('is-open')) {
                show('banner');
            }
        }, BANNER_DELAY);
    }
});
